import { connect } from "react-redux";

import { selectMaterialGroupsByPagesByTypesSorted } from "~/store/ducks/application/materials/materials";
import {
  selectRightSidebarActiveItems,
  selectRightSidebarActiveTab,
  closeSidebarRight
} from "~/store/ducks/user/uistate";
import { setShapeType, setDrawingMode } from "~/store/ducks/application/fabric";
import { showModal } from "~/store/ducks/domain/ui/modal";
import { goToPage } from "~/store/middlewares/page";
import TeachingMaterialList from "./TeachingMaterialList";

import {
  selectDisplayedPagesOnRightSidebar,
  selectDisplayedPages
} from "~/store/selectors/page";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

import { selectMarkedMaterialsByPages } from "~/store/selectors/dls";

const mapStateToProps = state => {
  const activeTab = selectRightSidebarActiveTab(state);
  const activePages = selectDisplayedPages(state);
  const pages = selectDisplayedPagesOnRightSidebar(state);
  const activeItems = selectRightSidebarActiveItems(state);
  const materials = selectMaterialGroupsByPagesByTypesSorted(pages)(
    activeItems
  )(state);

  return {
    activeTab,
    activePages,
    materials,
    isGreaterThanMedium: selectIsGreaterThanMedium(state),
    markedMaterials: selectMarkedMaterialsByPages(state)
  };
};

const mapDispatchToProps = dispatch => ({
  goToPage: page => dispatch(goToPage(page)),
  showModal: (kind, props) => {
    dispatch(showModal(kind, props));
  },
  closeSidebarRight: () => dispatch(closeSidebarRight()),
  openViewerModal: props => {
    dispatch(setDrawingMode(false));
    dispatch(setShapeType(null));
    dispatch(showModal("VIEWER", props));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeachingMaterialList);
